import defaultTheme from './defaultTheme';
const qvcTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#f25e43', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#f25e43', background: '#f25e43' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#f25e43' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#f25e43', border: '#f25e43', background: '#f25e43' }), field: {
        focus: '#f25e43',
        label: '#f25e43',
        icon: '#f25e43',
    } });
export default qvcTheme;
